module.exports = __webpack_public_path__ + "static/media/highlight.1c93ec24.png";